import { Injectable } from '@angular/core';
import { EventInvitation } from '@features/event-invitation/utils/models/event-invitation.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class EventInvitationService extends HttpHandler {
  getEventInvitation(hash: string): Observable<HttpResponse<EventInvitation>> {
    const url: string = environment.apiUrls.events.invitation;
    return this.post<HttpResponse<EventInvitation>>(url, { hash });
  }
}
